export const LEARNING_TAB_BAR_SECTION_ID = 'tab-bar-section';
